<template>
  <div class="px-10">
    <v-expansion-panels
      v-model="panel"
      multiple
      class="elevation-2"
    >
      <v-expansion-panel>
        <v-expansion-panel-header class="font-calibri font-16 font-weight-bold border-bottom-light-grey accordion-max-height">
          {{ section }} 
          <employee-profile-general-info-beneficiary-dialog-create
            v-if="panel.length > 0 && $hasPermissionTo(['create beneficiaries']) && !isMyProfile && !isResigned"
            :employee-uid="employeeUid"
            :beneficiaries="beneficiaries"
            @created="loadBeneficiaries"
          />
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-data-table
            :headers="headers"
            :items="beneficiaries"
            hide-default-footer
            dense
            class="border mt-4"
          >
            <template v-slot:item.name="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                  class="loading-bar"
                />  
                <span v-else>
                  {{ item.name }}
                </span>
              </div>
            </template>
            
            <template v-slot:item.ic_passport="{ item }">
              <v-skeleton-loader
                v-if="loading"
                type="list-item"
                class="loading-bar"
              />  
              <v-tooltip
                v-else
                bottom
              >
                <template v-slot:activator="{ on: tooltip }">
                  <v-icon
                    x-small
                    color="info"
                    v-on="{ ...tooltip }"
                  >
                    mdi-information-outline
                  </v-icon>
                </template>
                <div><b>{{ !item.ic ? 'Passport No.' :'Identity Card No.' }}</b></div>
              </v-tooltip>
              <span v-if="!loading">
                {{ !item.ic ? item.passport_no : item.ic }}
              </span>
            </template>

            <template v-slot:item.relationship="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                  class="loading-bar"
                />  
                <span v-else>
                  {{ item.relationship.name }}
                </span>
              </div>
            </template>

            <template v-slot:item.percentage="{ item }">
              <div>
                <v-skeleton-loader
                  v-if="loading"
                  type="list-item"
                  class="loading-bar"
                />  
                <span 
                  v-else
                >
                  {{ item.percentage_of_share }}%
                </span>
              </div>
            </template>

            <template v-slot:item.action="{ item }">
              <employee-profile-general-info-beneficiary-dialog-edit
                v-if="$hasPermissionTo(['update beneficiaries']) && !loading && !isMyProfile && !isResigned"
                :beneficiary="item"
                :beneficiaries="beneficiaries"
                @updated="loadBeneficiaries"
              />
              <employee-profile-general-info-beneficiary-dialog-delete
                v-if="$hasPermissionTo(['delete beneficiaries']) && !loading && !isMyProfile && !isResigned"
                :beneficiary="item"
                @deleted="loadBeneficiaries"
              />
            </template>

            <template v-slot:body.append>
              <tr>
                <td />
                <td />
                <td />

                <td class="font-weight-bold text-right">
                  TOTAL % OF SHARE = {{ totalPercentage }}%
                </td>

                <td />
              </tr>
            </template>
          </v-data-table>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    components: {
      EmployeeProfileGeneralInfoBeneficiaryDialogCreate: () => import('@/components/hris/employee/profile/general-info/beneficiary/DialogCreate'),
      EmployeeProfileGeneralInfoBeneficiaryDialogEdit: () => import('@/components/hris/employee/profile/general-info/beneficiary/DialogEdit'),
      EmployeeProfileGeneralInfoBeneficiaryDialogDelete: () => import('@/components/hris/employee/profile/general-info/beneficiary/DialogDelete'),
    },
    props: {
      employeeUid: {
        type: String,
        required: true,
      },
      isResigned: {
        type: Boolean,
        required: true,
      },
    },
    data () {
      return {
        section: 'Beneficiaries',
        beneficiaries: [],
        headers: [
          { 
            text: 'Name', 
            align: 'left',
            sortable: false,
            value: 'name',
          },
          {
            text: 'IC/Passport No.',
            align: 'left',
            sortable: false,
            value: 'ic_passport',
          },
          {
            text: 'Relationship',
            align: 'left',
            sortable: false,
            value: 'relationship',
          },
          { 
            text: 'Percentage of Share',
            align: 'right',
            sortable: false,
            value: 'percentage',
          },
          { 
            text: '',
            align: 'center',
            sortable: false,
            value: 'action', 
          },
        ],
        loading: false,
        panel: [0],
      }
    },
    computed: {
      ...mapState({ isCurrentUser: 'isMyProfile' }),
      isMyProfile () {
        return this.$store.state.isMyProfile
      },
      totalPercentage () {
        return this.beneficiaries.reduce((sum, b) => {
          return sum + Number(b.percentage_of_share || 0)
        }, 0)
      },
    },
    watch: {
      employeeUid: {
        immediate: true,
        handler (newVal, oldVal) {
          if (!_.isEmpty(newVal)) {
            this.loadBeneficiaries()
          }
        },
      },
    },
  
    methods: {
      loadBeneficiaries () {
        this.loading = true

        this.$api.beneficiaries().list(this.employeeUid)
          .then(res => {
            this.beneficiaries = res.data

            this.loading = false
          })
      },
    },
  }
</script>

<style scoped>
.font-calibri{
  font-family: Calibri !important;
}

.font-16{
  font-size:16px;
}

.border-bottom-light-grey{
  border-bottom:1px solid #e6e6e6;
}

.accordion-max-height{
  max-height: 36px !important;
}

.border{
  border:1px solid #e6e6e6;
}

.loading-bar >>> .v-skeleton-loader__list-item.v-skeleton-loader__bone{
  padding-left:0px
}
</style>
